import React from "react";
import { FaRegCheckCircle } from "react-icons/fa";
import { AiOutlineExclamationCircle } from "react-icons/ai";

const ValidationMessageBox = ({ success, heading, description }) => {
    return (
        <div className={`validation-box flex gap-2 w-full py-4 mt-6 px-5 rounded-lg border-2 ${success ? 'bg-[#E8F5E9] border-[#54A958]' : 'bg-[#FFEBEE] border-[#F44336]'}`}>
            {
                success
                ?
                    <FaRegCheckCircle size={22} className='text-[#54A958] mt-[1px]'/>
                :
                    <AiOutlineExclamationCircle size={22} className='text-[#F44336] mt-[1px]'/>
            }
            <div className="flex flex-col">
                <span className="font-medium">{heading}</span>
                <span className={`font-light ${success ? 'text-[#6C838C]' : 'text-[#57717C]'}`}>{description}</span>
            </div>
        </div>
    )
}

export default ValidationMessageBox;